import React from 'react'
import { TaskCard } from '../../types/task-board'

interface TaskCardHeaderProps {
  card: TaskCard
  onClose: () => void
}

export const TaskCardHeader: React.FC<TaskCardHeaderProps> = ({ card, onClose }) => {
  return (
    <div style={{
      padding: window.innerWidth < 768 ? '10px 15px' : '15px 20px',
      borderBottom: '1px solid #e9ecef',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      backgroundColor: '#f8f9fa'
    }}
    >
      <h3 style={{
        margin: 0,
        fontWeight: 600,
        fontSize: window.innerWidth < 768 ? '18px' : '20px',
        wordBreak: 'break-word'
      }}
      >
        {card.title}
      </h3>
      <button
        onClick={onClose}
        style={{
          background: 'none',
          border: 'none',
          fontSize: '24px',
          cursor: 'pointer',
          padding: '0 5px',
          marginLeft: '10px',
          flexShrink: 0
        }}
      >
        ×
      </button>
    </div>
  )
}
